<template>
    <div class="da-expansion-panel">
        <div class="da-expansion-header" v-on:click.prevent="clicked">
            <span class="da-expansion-header-title">
                <slot name="header">
                    {{isExpanded ? 'Collapse Details' : 'Expand Details'}}
                </slot>
            </span>
            <font-awesome-icon :icon="['fal', 'angle-up' ]" class="fa-2x da-expansion-icon" :class="{'da-rotate-180': !isExpanded}"></font-awesome-icon>
        </div>
        <div class="da-expansion-content" v-bind:style="heightTransitionCss">
            <div ref="listBody">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from 'vue'
import { faAngleUp, faAngleDown } from '@fortawesome/pro-light-svg-icons'
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core'

faLibrary.add(faAngleUp, faAngleDown);

export default defineComponent({
    data() {
        return {
            isExpanded: false,
            heightTransitionCss: { height: "0px" }
        }
    },
    methods:{
        clicked() {
            this.isExpanded = !this.isExpanded;
            this.heightTransitionCss.height = this.isExpanded ? `${(this.$refs.listBody as any).clientHeight}px` : "0px";
        }
    }
})
</script>
<style>
.da-expansion-header {
    cursor: pointer;
}
.da-expansion-icon {
    vertical-align: middle;
    margin-left: 8px;
    transition: transform .2s;
}
.da-rotate-180 {
    transform: rotate(180deg);
}
.da-expansion-content {
    transition: height .2s ease-in-out;
    overflow: hidden;
}
</style>